import { Components } from 'appworks/components/components';
import { PromptComponent } from 'appworks/components/prompt/prompt-component';
import { SpineContainer } from 'appworks/graphics/pixi/spine-container';
import { FowlFlingBonusBackgroundComponent } from 'components/bonus/fling/fowl-fling-bonus-background-component';
import { FowlFlingBonusComponent } from 'components/bonus/fling/fowl-fling-bonus-component';
import { FowlFlingBonusTransitionComponent } from 'components/bonus/fling/fowl-fling-bonus-transition-component';
import { FowlEggPickBonusComponent } from 'components/bonus/pick/fowl-egg-pick-bonus-component';
import { FowlBigWinFactory } from 'components/factories/fowl-big-win-factory';
import { FowlReelMatrixFactory } from 'components/factories/fowl-reel-matrix-factory';
import { FowlBackgroundFXComponent } from 'components/fowl-background-fx-component';
import { FowlBonusTransitionComponent } from 'components/fowl-bonus-transition-component';
import { FowlCelebrateWinComponent } from 'components/fowl-celebrate-win-component';
import { FowlLadderComponent } from 'components/fowl-ladder-component';
import { FowlSlingoReelHighlightComponent } from 'components/fowl-slingo-reel-highlight-component';
import { FowlTicketMatrixComponent } from 'components/fowl-ticket-matrix-component';
import { SocialFowlBetBarComponent } from 'components/social-bet-bar-component';
import { SocialGMRAlertComponent } from 'components/social-gmr-alert-component';
import { SocialGMRPreloaderComponent } from 'components/social-preloader-component';
import { SocialSlingoCelebrationComponent } from 'components/social-slingo-celebration-component';
import { LayerNames } from 'game-layers';
import { GMRSuperSpinWheelComponent } from 'gaming-realms/components/gmr-super-spin-wheel-component';
import { SlingoCoinHopperComponent } from 'slingo/components/slingo-coin-hopper-component';
import { SlingoFooterComponent } from 'slingo/components/slingo-footer-component';
import { SlingoSpinsCounterComponent } from 'slingo/components/slingo-spins-counter-component';
import { CountMode } from 'slotworks/components/bigwin/big-win-component';
import { GenericComponentFactory } from 'slotworks/components/factories/generic-component-factory';

/**
 * FowlSetup.setupComponents() override
 */
export function setupComponents() {
    SpineContainer.AUTO_UPDATE_SPEED = true;

    Components.register(new GenericComponentFactory(PromptComponent, { usePromptLayerAsClickListener: true }), 0);
    // Components.register(new GenericComponentFactory(FowlBetBarComponent));
    Components.register(new GenericComponentFactory(SocialFowlBetBarComponent));
    Components.register(new GenericComponentFactory(FowlCelebrateWinComponent));

    Components.register(
        new FowlBigWinFactory(CountMode.LINEAR, false, [
            {
                threshold: 0,
                countTime: 3000,
                waitTime: 3000,
                scene: "win",
            },
            {
                threshold: 20,
                countTime: 6000,
                waitTime: 3000,
                scene: "bigwin",
            },
            {
                threshold: 50,
                countTime: 6000,
                waitTime: 3000,
                scene: "superwin",
            },
            {
                threshold: 100,
                countTime: 6000,
                waitTime: 3000,
                scene: "megawin",
            },
        ])
    );

    // Components.register(new GenericComponentFactory(GMRPreloaderComponent), null);
    Components.register(new GenericComponentFactory(SocialGMRPreloaderComponent), null);
    // Components.register(new GenericComponentFactory(GMRAlertComponent), 0);
    Components.register(new GenericComponentFactory(SocialGMRAlertComponent), 0);
    Components.register(new GenericComponentFactory(GMRSuperSpinWheelComponent));

    Components.register(new FowlReelMatrixFactory(), 3);

    Components.register(new GenericComponentFactory(SlingoFooterComponent));
    // Components.register(new GenericComponentFactory(SlingoCelebrationComponent, LayerNames.CelebrationContent));
    Components.register(new GenericComponentFactory(SocialSlingoCelebrationComponent, LayerNames.CelebrationContent));
    Components.register(new GenericComponentFactory(SlingoSpinsCounterComponent, LayerNames.SpinCounter));
    Components.register(new GenericComponentFactory(SlingoCoinHopperComponent));
    Components.register(new GenericComponentFactory(FowlLadderComponent));
    Components.register(new GenericComponentFactory(FowlSlingoReelHighlightComponent));

    Components.register(new GenericComponentFactory(FowlTicketMatrixComponent, { parallelCelebration: false }), 3);

    Components.register(new GenericComponentFactory(FowlFlingBonusComponent));
    Components.register(new GenericComponentFactory(FowlFlingBonusBackgroundComponent));
    Components.register(new GenericComponentFactory(FowlFlingBonusTransitionComponent));
    Components.register(new GenericComponentFactory(FowlEggPickBonusComponent));
    Components.register(new GenericComponentFactory(FowlBackgroundFXComponent));
    Components.register(new GenericComponentFactory(FowlBonusTransitionComponent));
}
